// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation/Navigation';
import Hero from './components/Hero/Hero';
import Features from './components/Features/Features';
import HowItWorks from './components/HowItWorks/HowItWorks';
import Pricing from './components/Pricing/Pricing';
import Stats from './components/Stats/Stats';
import Footer from './components/Footer/Footer';
import WaitlistModal from './components/Modal/WaitlistModal';
import FloatingShapes from './components/FloatingShapes/FloatingShapes';
import PasswordProtection from './components/PasswordProtection/PasswordProtection';
import PitchDeckPage from './pages/pitch-deck/PitchDeckPage';
import BusinessPlan from './pages/business-plan/BusinessPlan';
import TechDeck from './pages/Technology/TechDeck';
import Marketing from './pages/Marketing/Marketing';
import IP from './pages/IP/IP';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check if user was previously authenticated (stored in sessionStorage)
  useEffect(() => {
    const authStatus = sessionStorage.getItem('gushome_authenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleAccessGranted = () => {
    setIsAuthenticated(true);
    // Store authentication status for the session
    sessionStorage.setItem('gushome_authenticated', 'true');
  };

  // If not authenticated, show password protection
  if (!isAuthenticated) {
    return <PasswordProtection onAccessGranted={handleAccessGranted} />;
  }

  // If authenticated, show the main application
  return (
    <Router>
      <div className="App">
        <FloatingShapes />
        <Navigation />
        
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <Stats />
              <Features />
              <HowItWorks />
              <Pricing />
              <Footer />
            </>
          } />
          <Route path="/pitch-deck" element={<PitchDeckPage/>} />
          <Route path="/business-plan" element={<BusinessPlan/>} />
          <Route path="/tech-deck" element={<TechDeck/>} />
          <Route path="/marketing" element={<Marketing/>} />
          <Route path="/ip" element={<IP/>} />
        </Routes>
        
        <WaitlistModal />
      </div>
    </Router>
  );
}

export default App;